import React from 'react';

export default ({ fillColor = '#60034C' }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.27473 15.1111C1.89362 15.1111 1.56726 14.9756 1.29563 14.7044C1.02401 14.4332 0.888425 14.1069 0.888887 13.7253V4.02439C0.888887 3.64328 1.0247 3.31691 1.29632 3.04529C1.56795 2.77366 1.89408 2.63808 2.27473 2.63854H8.45906L7.07321 4.02439H2.27473V13.7253H11.9756V8.90948L13.3615 7.52364V13.7253C13.3615 14.1064 13.2257 14.4328 12.954 14.7044C12.6824 14.976 12.3563 15.1116 11.9756 15.1111H2.27473ZM10.0181 3.03697L11.0055 4.00706L6.43226 8.58035V9.56776H7.40235L11.993 4.97715L12.9804 5.94725L8.38976 10.5379C8.26273 10.6649 8.11537 10.7661 7.94768 10.8414C7.77999 10.9166 7.60399 10.9541 7.41967 10.9536H5.73934C5.54301 10.9536 5.37833 10.8871 5.24528 10.754C5.11224 10.621 5.04595 10.4565 5.04642 10.2607V8.58035C5.04642 8.39557 5.08106 8.21934 5.15035 8.05165C5.21965 7.88396 5.31781 7.73683 5.44485 7.61026L10.0181 3.03697ZM12.9804 5.94725L10.0181 3.03697L11.7504 1.30467C12.0276 1.0275 12.3597 0.888916 12.7469 0.888916C13.134 0.888916 13.4601 1.0275 13.7253 1.30467L14.6953 2.29208C14.961 2.5577 15.0938 2.88107 15.0938 3.26217C15.0938 3.64328 14.961 3.96664 14.6953 4.23226L12.9804 5.94725Z"
        fill={fillColor}
      />
    </svg>
  );
};
